<section class="operations-page">
    <header class="operations-page__header">
        <div>
            <h2 class="operations-page__title">Event Subscriptions</h2>
            <p class="operations-page__lead">View vision service webhook subscriptions for platform cameras.
                Subscriptions are managed automatically based on Camera Analytics configuration.
                KYRA status is the subscription record in KYRA’s database; it does not by itself prove the
                Eagle Eye remote still exists. Environment is the KYRA application environment that owns the local row.
            </p>
        </div>
        <div class="operations-actions">
            <button type="button" class="operations-btn" [disabled]="comparing || listState.loading"
                    (click)="refreshSubscriptions()"
                    [attr.aria-busy]="comparing">
                {{ comparing ? 'Refreshing…' : 'Refresh' }}
            </button>
        </div>
    </header>

    <div class="subscription-env-banner"
         [class.subscription-env-banner--unresolved]="!environmentResolved">
        <strong>{{ environmentBannerTitle }}</strong>
        <p>{{ environmentBannerDetail }}</p>
        <p>Last successful EEN comparison: {{ lastSuccessfulSyncLabel }}</p>
        <p *ngIf="comparisonError">{{ comparisonError }}</p>
    </div>

    <div class="subscription-consistency-banner subscription-consistency-banner--mismatch"
         *ngIf="showMismatchWarning"
         role="alert">
        <div class="subscription-consistency-banner__body">
            <strong>Subscription drift detected</strong>
            <p>{{ mismatchWarningCopy }}</p>
        </div>
        <button type="button"
                class="operations-btn"
                (click)="reviewSynchronization()">
            Review synchronization
        </button>
    </div>

    <div class="subscription-consistency-banner subscription-consistency-banner--unverified"
         *ngIf="showUnverifiedWarning"
         role="status">
        <div class="subscription-consistency-banner__body">
            <strong>Synchronization unverified</strong>
            <p>{{ unverifiedWarningCopy }}</p>
        </div>
        <button type="button"
                class="operations-btn"
                (click)="reviewSynchronization()">
            Review synchronization
        </button>
    </div>

    <section class="operations-page__card operations-form-card" *ngIf="showReplaceForm && selectedSubscription">
        <h3 class="operations-page__heading">Replace {{ selectedSubscription.subscription_id }}</h3>
        <div class="operations-form-grid">
            <div class="operations-form-field">
                <label for="replace-camera-ids">Camera IDs</label>
                <textarea id="replace-camera-ids" rows="3" [(ngModel)]="cameraIdsInput"></textarea>
            </div>
            <div class="operations-form-field">
                <label for="replace-event-type">Event Type</label>
                <select id="replace-event-type" [(ngModel)]="selectedEventType">
                    <option *ngFor="let option of eventTypeOptions" [value]="option.eventTypeId">
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
        <div class="operations-form-actions">
            <button type="button" class="operations-btn" [disabled]="saving" (click)="closeDialogs()">Cancel</button>
            <button type="button" class="operations-btn operations-btn--primary" [disabled]="saving"
                    (click)="submitReplace()">
                Replace
            </button>
        </div>
    </section>

    <div class="operations-page__card">
        <p class="operations-page__loading" *ngIf="listState.loading">Loading subscriptions…</p>

        <div class="operations-table-wrapper" *ngIf="!listState.loading">
            <table class="operations-table">
                <thead>
                <tr>
                    <th>EEN Subscription ID</th>
                    <th>Event Types</th>
                    <th>KYRA status</th>
                    <th>Environment</th>
                    <th>Organization</th>
                    <th>Remote comparison</th>
                    <th>Cameras</th>
                    <th>Webhook URL</th>
                    <th>Updated</th>
                    <th class="operations-table__actions"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="!subscriptions.length">
                    <td colspan="10" class="operations-table__empty">
                        No subscriptions found. Subscriptions are managed automatically based on Camera Analytics
                        configuration.
                    </td>
                </tr>
                <tr *ngFor="let subscription of subscriptions">
                    <td>{{ subscription.subscription_id }}</td>
                    <td>{{ formatEventTypes(subscription.event_types) }}</td>
                    <td>
                        <span [class]="statusClass(subscription.status)"
                              [attr.title]="kyraStatusHelp">
                            {{ kyraStatusLabel(subscription) }}
                        </span>
                    </td>
                    <td>
                        <span [class]="environmentClass(subscription)"
                              title="KYRA application environment that owns this local subscription record">
                            {{ environmentLabel(subscription) }}
                        </span>
                    </td>
                    <td>{{ organizationLabel(subscription) }}</td>
                    <td>
                        <span [class]="remoteClass(subscription)"
                              [attr.title]="remoteHelp(subscription)">
                            {{ remoteLabel(subscription) }}
                        </span>
                    </td>
                    <td>{{ (subscription.camera_ids || []).join(', ') || '—' }}</td>
                    <td>{{ subscription.webhook_url }}</td>
                    <td>{{ formatTimestamp(subscription.updated_at) }}</td>
                    <td class="operations-table__actions">
                        <div class="operations-actions" *ngIf="showLifecycleActions(subscription)">
                            <button type="button"
                                    class="operations-btn"
                                    [disabled]="!canReplace(subscription)"
                                    [title]="mutationReason(subscription) || ''"
                                    (click)="openReplaceForm(subscription)">
                                Replace
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <app-vte-pagination
                    [currentPage]="listState.currentPage"
                    [pageSize]="listState.pageSize"
                    [totalRecords]="listState.totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)"
            ></app-vte-pagination>
        </div>
    </div>
</section>
